module.exports = __webpack_public_path__ + "img/img-6.32c95527.png";